import firebase from "./firebase";

const gtag = window.gtag;

class Tracking {
  logEvent(eventName, eventParams, options) {
    firebase.analytics().logEvent(eventName, eventParams, options);
    gtag("event", eventName, eventParams);
  }
}

export default new Tracking();
